import React from "react";
import { Container, Button } from "../components/ui";

const NotFound = () => (
  <Container className="flex flex-col items-center py-24 text-center md:py-32">
    <p className="text-sm font-semibold uppercase tracking-wider text-primary">
      404
    </p>
    <h1 className="mt-3 text-3xl font-bold tracking-tight text-navy md:text-4xl">
      This page is out of bounds
    </h1>
    <p className="mt-3 max-w-md text-muted">
      The page you're looking for doesn't exist or has moved.
    </p>
    <div className="mt-8 flex flex-wrap justify-center gap-3">
      <Button to="/">Back to home</Button>
      <Button to="/rankings" variant="secondary">
        View rankings
      </Button>
    </div>
  </Container>
);

export default NotFound;
